'use client';

import { usePathname } from 'next/navigation';
import PdpHeader from './pdp-header';
import SearchboxHeader from './searchbox-header';
const MobileHeader = () => {
  const pathname = usePathname();
  const isPDP = pathname.includes('/products/');
  const isHomepage = pathname === '/';
  return <div className='layout-container relative z-10 flex h-14 items-center justify-between bg-white lg:h-[90px]' data-sentry-component="MobileHeader" data-sentry-source-file="index.tsx">
            {isPDP ? <PdpHeader /> : <SearchboxHeader hideBackButton={isHomepage} />}
        </div>;
};
export default MobileHeader;